const create = (api) => {

    const getIdp = () => {
      return api.get(`/idp-admin`)
    }
    const updateIdp = (id, actionType) => {
        const data = { id, actionType };
        return api.put(`/idp-admin/${id}/${actionType}`, data);
      }
    
    return {
      getIdp,
      updateIdp
    }
  
  }
  
  export default {
    create
  }